<template>
  <section class="evento-lux">
    <div class="stars-container">
      <div class="star" v-for="n in 50" :key="n" :style="generateStarStyle()"></div>
    </div>

    <article ref="card" class="card" aria-label="Celebration"><br><br><br><br>
      <h3 class="titulo-script">Celebration</h3>

      <img class="icono" src="@/assets/10.avif" alt="" />

      <p class="lugar">Party Venue Tampa</p>

      <p class="hora">5:00 PM</p>

      <p class="direccion">
      5537 Sheldon Rd Suite B<br> Tampa Florida 33615
      </p>

      <a
        ref="btn"
        class="btn-rosa"
        href="https://maps.app.goo.gl/nPyVzPMp7xATsFVr6"
        target="_blank"
        rel="noopener"
      >
        How to get there?
        <span class="sheen" aria-hidden="true"></span>
      </a>
    </article>
  </section>
</template>


<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup () {
    const card = ref(null)
    const linea = ref(null)
    const btn = ref(null)

    // Función para generar estrellas aleatorias
    const generateStarStyle = () => {
      const top = Math.random() * 100;
      const left = Math.random() * 100;
      const size = Math.random() * 2 + 1; // Estrellas un poco más finas para este fondo
      const duration = Math.random() * 3 + 2;
      const delay = Math.random() * 5;
      
      return {
        top: `${top}%`,
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      };
    };

    const animCard = (cardEl, lineaEl, btnEl) => {
      const $ = gsap.utils.selector(cardEl)
      const icono = $('.icono')
      const titulo = $('.titulo-script')
      const nota = $('.nota-lugar')
      const hora = $('.hora')
      const lugar = $('.lugar')
      const imagenWrapper = $('.imagen-salon-wrapper')
      const dir = $('.direccion')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 88%',
          end: 'bottom 65%',
          scrub: 0.25
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, { opacity: 0, y: 22, filter: 'blur(4px)', duration: 0.38 })
        .from(icono, { opacity: 0, y: 16, filter: 'blur(3px)', duration: 0.35 }, '-=0.12')
        .from(titulo, { opacity: 0, y: 18, filter: 'blur(3px)', duration: 0.38 })
        .from(nota, { opacity: 0, y: 10, duration: 0.34 }, '-=0.18')
        .from(hora, { opacity: 0, x: -22, duration: 0.35 }, '-=0.12')
        .from(lugar, { opacity: 0, x: 22, duration: 0.35 }, '-=0.2')
        .from(
          imagenWrapper,
          {
            opacity: 0,
            y: 24,
            scale: 0.96,
            filter: 'blur(3px)',
            duration: 0.45
          },
          '-=0.16'
        )
        .from(dir, { opacity: 0, y: 14, duration: 0.34 }, '-=0.12')
        .from(btnEl, { opacity: 0, y: 12, scale: 0.97, duration: 0.34 }, '-=0.1')

      // Animación de la línea
      gsap.fromTo(
        lineaEl,
        { scaleY: 0, transformOrigin: 'top' },
        {
          scaleY: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: cardEl,
            start: 'top 80%',
            end: 'bottom 70%',
            scrub: 0.35
          }
        }
      )

      // Sheen del botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 88%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -110, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.6, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      animCard(card.value, linea.value, btn.value)
    })

    return { card, linea, btn, generateStarStyle }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root {
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux {
  position: relative; /* Para las estrellas */
  min-height: 100%;
  padding: 0px 18px 64px;
  overflow: hidden; /* Evita scroll por las estrellas */
  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.516) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/descarga (3) - copia - copia.png');

  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;

  color: #ffffff;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== SISTEMA DE ESTRELLAS ==================== */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  opacity: 0.3;
  box-shadow: 0 0 8px white;
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0% { opacity: 0.1; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.2); }
  100% { opacity: 0.1; transform: scale(1); }
}

/* ==================== TARJETA ==================== */
.card {
  position: relative;
  z-index: 1; /* Por encima de las estrellas */
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 8px;
  text-align: center;
  margin-top:100px;
  background:#e4cdc200;
}

/* Icono discreto */
.icono {
  width: 52px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: brightness(0) invert(1)
          drop-shadow(0 1px 0 rgba(0, 0, 0, 0.05));
  opacity: 0.92;
}

.imagen-salon-wrapper {
  margin: 8px auto 14px;
  overflow: hidden;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
  border: 10px double #f1a6c8;
  border-radius: 20px;
}

.imagen-salon {
  display: block;
  width: 100%;
  height: auto;
  transform-origin: center;
}

/* Tipos */
.titulo-script {
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 60px !important;
  color: #767a4f;
  letter-spacing: 0.4px;
  margin: 4px 0 8px;
}
.hora {
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: #ffff;
  margin: 0 0 6px;
}
.lugar {
  font-family: 'cursivatitulo', serif;
  font-size: 24px !important;
  color: #afb0a3;
  font-weight: 500;
  margin: 0 4px 66px; /* Ajustado según tu código original */
  margin: 0 4px 6px;
  letter-spacing: 0.0;
}
.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color: #afb0a3;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 10px;
  max-width: 90%;
}

.nota-lugar {
  font-family: 'padres', serif;
  font-size: 14px;
  color: #afb0a3;
  padding: 8px 10px;
  margin: 4px 0 16px;
  max-width: 100%;
  border-radius: 10px;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #f3f3f3 100%
  );
  color: #1f1f1f;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  transition:
    transform 0.18s cubic-bezier(.4,0,.2,1),
    box-shadow 0.18s cubic-bezier(.4,0,.2,1),
    filter 0.18s ease;
  z-index: 0;
}

/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 12px;
}
.linea {
  width: 1px;
  height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script { font-size: 32px; }
  .hora { font-size: 22px; }
  .lugar { font-size: 16px; letter-spacing: 0.08em; }
}

@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; animation: none !important; }
}

.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;
  margin-bottom: -80px;
  overflow: visible;
}

.lux-flores {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.08));
  opacity: 0.98;
}
</style>